import React, { FunctionComponent } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

type OnsiteProvidersSearchIllustrationProps = SvgProps & {
  size?: number
  withBackground?: boolean
  hasBorder?: boolean
}

export const OnsiteProvidersSearchIllustration: FunctionComponent<OnsiteProvidersSearchIllustrationProps> = ({
  size = 56,
  withBackground = false,
  hasBorder = true,
  ...props
}) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 137 137' fill='none' {...props}>
      {withBackground && (
        <>
          <Path
            fill={hasBorder ? '#fff' : '#FFE9E3'}
            d='M68.981.462c-9.456 0-18.63 1.622-27.27 4.82C21.144 12.904 6.685 29.805 2.04 51.651-1.031 65.893-.64 79.067 3.246 91.905c4.96 16.395 17.135 30.221 33.403 37.931 8.075 3.837 17.353 6.027 27.57 6.509 1.314.059 2.648.092 3.975.092 8.197 0 16.444-1.124 24.511-3.338.62-.155 1.21-.314 1.833-.498 7.25-2.123 13.775-5.48 19.357-9.966 6.062-4.843 11.051-10.983 14.814-18.239a74.982 74.982 0 0 0 2.234-4.735c4.304-9.995 6.384-21.184 6.015-32.37-.173-4.947-.909-10.204-2.182-15.64-2.095-8.82-5.512-17.116-9.881-24.003a66.9 66.9 0 0 0-3.384-4.8C113.657 12.719 101.42 5.609 86.135 2.3A81.04 81.04 0 0 0 68.985.465L68.98.462Z'
          />
          <Path
            fill='#FFE9E3'
            d='M131.081 67.475c-.168-4.74-.893-9.65-2.036-14.532-1.868-7.865-4.938-15.618-9.148-22.257-.977-1.505-1.979-2.956-3.067-4.35-7.894-10.18-19.858-15.843-32.103-18.494-13.639-2.956-28.142-2.092-41.253 2.762C24.507 17.632 11.593 33.028 7.38 52.832c-1.62 7.502-2.093 15.98-1.368 24.127h-.057c.42 4.63 1.257 9.148 2.51 13.304 4.66 15.396 15.981 27.614 30.403 34.447 7.81 3.709 16.538 5.55 25.41 5.969 9.064.42 18.269-.725 26.778-3.067a33.5 33.5 0 0 0 1.646-.447c6.665-1.952 12.467-4.965 17.432-8.953 5.412-4.323 9.873-9.762 13.333-16.427a68.538 68.538 0 0 0 2.063-4.38c4.072-9.457 5.886-19.72 5.523-29.9l.027-.027v-.002Z'
          />
          <Path
            fill='#DDD5D0'
            d='M106.355 52.635H63.987v-3.968a2.08 2.08 0 0 1 2.08-2.08h38.209a2.08 2.08 0 0 1 2.079 2.08v3.968Z'
          />
        </>
      )}
      <Path
        fill='#CEB9A7'
        d='M32.712 69.254v34.135h73.675V52.581H63.999v15.343c0 .644-.501 1.167-1.12 1.167H34.661c-1.077 0-1.949-.954-1.949.163Z'
      />
      <Path
        fill='#DDD5D0'
        d='M86.701 103.348H72.508V84.281c0-.91.738-1.646 1.646-1.646h10.901c.91 0 1.646.739 1.646 1.646v19.067ZM89.197 75.959h7.508c.633 0 1.145-.513 1.145-1.145V61.86c0-.632-.512-1.144-1.145-1.144h-7.508c-.632 0-1.145.512-1.145 1.144v12.954c0 .632.513 1.145 1.145 1.145ZM73.403 75.959h7.508c.633 0 1.145-.513 1.145-1.145V61.86c0-.632-.512-1.144-1.144-1.144h-7.509c-.632 0-1.145.512-1.145 1.144v12.954c0 .632.513 1.145 1.145 1.145ZM54.87 91.534h7.508c.633 0 1.145-.513 1.145-1.145V77.436c0-.633-.513-1.145-1.145-1.145H54.87c-.632 0-1.145.513-1.145 1.145v12.953c0 .633.513 1.145 1.145 1.145ZM39.08 91.534h7.51c.631 0 1.144-.513 1.144-1.145V77.436c0-.633-.513-1.145-1.145-1.145h-7.508c-.632 0-1.145.513-1.145 1.145v12.953c0 .633.513 1.145 1.145 1.145ZM32.668 65.22v3.969h31.341V63.14H34.75c-1.15 0-2.082.932-2.082 2.08Z'
      />
      <Path
        fill='#F69170'
        d='M47.765 63.57a3.265 3.265 0 0 1-4.51-.101c-3.835-3.816-11.428-12.303-11.918-20.124-.543-8.661 6.309-15.025 14.771-14.982 4.353.025 8.577 2.363 11.027 5.939 2.957 4.312 3.178 9.604 1.262 14.384l-.128.314c-2.292 5.48-6.14 10.569-10.504 14.57Z'
      />
      <Path
        fill='#FFE9E3'
        d='M46.16 49.362c3.9-.172 6.92-3.498 6.746-7.429-.174-3.93-3.475-6.977-7.374-6.805-3.9.172-6.92 3.498-6.746 7.429.174 3.93 3.475 6.977 7.375 6.805Z'
      />
      <Path
        fill='#5DAD3E'
        d='M86.85 103.42h26.624c.214-.254.389-.571.487-.937 1.449-5.24-2.721-9.992-6.42-8.2-1.682-3.532-3.058-5.857-6.978-5.833-2.715.017-5.153 2.101-6.407 4.945-1.858-1.64-4.417-1.877-6.338-.041-2.342 2.24-3.074 7.212-.968 10.066Z'
      />
    </Svg>
  )
}
